// @flow


const interceptor = (callback: Function) => (Constructor: Class<*>) => {
	return class extends Constructor {
		constructor (...args: *[]) {
			super(...args);

			callback(...args);
		}
	};
};


export default interceptor;
